import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)

const state={
	userInfo: !JSON.parse(localStorage.getItem('userInfo'))?null:JSON.parse(localStorage.getItem('userInfo')),
	Loading:false,
	selectedRecorded:[],
	videoUrl:'',
	recording:[],		//录播数组
	wxShare:{},     //微信分享 
	meeting_id:''   //会议id

}
export default new Vuex.Store({
	state,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js